import React, { useState } from "react";
import ReactQuill from "react-quill";
import "../../Styles/Form/FormCreate.css";
import singleChoiceIcon from "../../Assets/singleChoiceIcon.svg";
// import multiChoiceIcon from "../../Assets";
import optionDND from "../../Assets/optionDND.svg";
import answerKeyIcon from "../../Assets/answerKeyIcon.png";
import optionTrash from "../../Assets/optionTrash.svg";
import { useDispatch } from "react-redux";
import {
  addOptionSingleChoiceop,
  deleteSingleChoiseOption,
  removeFeedback,
  updateCorrectAnswer,
  updateItemQuestion,
  updateQUestionFeedback,
  updateQuizPointValue,
  updateRequiredChange,
  updateSingleChoiceOp,
} from "../../Redux/Reducer/FormSlices";
import addSingleOptionButton from "../../Assets/addSingleOptionButton.svg";

import Addiconfontsizes from "../../Assets/Addiconfontsizes.png";
import reduceiconfontsizes from "../../Assets/reduceiconfontsizes.png";
import FeedBackModal from "./FeedBackModal/FeedBackModal";

import editNotificationicon from "../../Assets/editNotificationicon.png";
import deleteNotificationIcon from "../../Assets/deleteNotificationIcon.png";
import editStateTick from "../../Assets/editStateTick.png";

const MultipleChoiceQuestion = ({
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
  generalSettings,
}) => {
  const [multiOtionFocused, setMultiOptionfocused] = useState(null);
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleOptionTextChange = (optionIndex, option) => {
    dispatch(
      updateSingleChoiceOp({
        optionIndex,
        questionIndex,
        containerIndex,
        option,
      })
    );
  };

  const deleteSingleChoiceOp = (optionIndex) => {
    dispatch(
      deleteSingleChoiseOption({ optionIndex, questionIndex, containerIndex })
    );
  };

  const addNewOption = () => {
    dispatch(addOptionSingleChoiceop({ questionIndex, containerIndex }));
  };

  const handleRequiredChange = (questionIndex, containerIndex, value) => {
    dispatch(updateRequiredChange({ questionIndex, containerIndex, value }));
  };

  const [showAnswerKey, setShowAnswerKey] = useState(null);
  //handelAddAnswerKey
  const handelAddAnswerKey = (questionId) => {
    setShowAnswerKey(questionId);
  };

  const [isShowFeedbackModal, setShowFeedbackModal] = useState(false);

  const closeFeedbackModal = () => {
    console.log("closeFeedbackModal");
    setShowFeedbackModal(!isShowFeedbackModal);
  };

  //update answer point value in redux
  const handelChangePointValue = (point) => {
    dispatch(updateQuizPointValue({ point }));
  };

  //add answer to question
  const addAnswerList = (option, optionIndex) => {
    console.log(questionIndex, containerIndex, option);
    dispatch(
      updateCorrectAnswer({
        questionIndex,
        containerIndex,
        option: option.optionText,
      })
    );
  };

  const updatedCorrectAnswer = () => {
    setShowAnswerKey(null);
  };

  const [showCorrect, setShowCorrect] = useState("Incorrect answer");
  const handelUpdateFeedBack = (e) => {
    dispatch(
      updateQUestionFeedback({
        questionIndex,
        containerIndex,
        name: e.target.name,
        value: e.target.value,
      })
    );
  };

  const handelDeleteFeedBack = (name) => {
    dispatch(removeFeedback({ containerIndex, questionIndex, name }));
    // console.log(question);
  };
  const handelEditFeedBack = () => {
    setShowFeedbackModal(true);
  };
  return (
    <>
      <FeedBackModal
        isOpen={isShowFeedbackModal}
        onClose={closeFeedbackModal}
        showCorrect={showCorrect}
        setShowCorrect={setShowCorrect}
        onChange={handelUpdateFeedBack}
        answerFeedback={question}
      />
      {showAnswerKey === question.id ? (
        <>
          <div className="ShortAnswer_container">
            <div>Choose correct answer</div>
            <div className="Questionview_container">
              {questionIndex + 1}.
              <div
                className="Questionview_text"
                dangerouslySetInnerHTML={{ __html: question.question }}
              ></div>
            </div>
            <div
              className="questionView_OPtionContainer"
              style={{ gap: "2px" }}
            >
              {question.options.map((option, idx) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "1rem",
                    backgroundColor:
                      question?.correctAnswer?.includes(option.optionText) &&
                      "rgba(27, 81, 187, 0.1)",
                    padding: "0.8rem 1rem",
                    borderRadius: "8px",
                  }}
                  key={idx}
                  onClick={() => addAnswerList(option)}
                >
                  <div style={{ display: "flex", gap: "1rem" }}>
                    <input
                      type="radio"
                      checked={question?.correctAnswer?.includes(
                        option.optionText
                      )}
                      style={{
                        width: "24px",
                        height: "24px",
                        transform: "scale(1)",
                      }}
                    />
                    <div> {option.optionText}</div>
                  </div>
                  {question?.correctAnswer?.includes(option.optionText) && (
                    <div>
                      <img src={editStateTick} alt="editStateTick" />
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="answer-key-component-bottom">
              <div
                className="answer-feedback-text"
                onClick={closeFeedbackModal}
              >
                Add answer feedback
              </div>
              <div className="input-text-sizes">
                <input
                  type="number"
                  placeholder=""
                  name="quizSettings.questionPointValue"
                  className="inputValue-for-form-name"
                  value={generalSettings.quizSettings.questionPointValue || ""}
                  onChange={(e) => handelChangePointValue(e.target.value)}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <img src={Addiconfontsizes} alt="addicon" />
                  <img src={reduceiconfontsizes} alt="reduce" />
                </div>
                <div className="text-sizes-model">Points</div>
              </div>
            </div>
            {question.currentAnswerFeedback !== "" && (
              <div className="show-feedback-container">
                <div className="show-feedback-container-text-container">
                  <div>FEEDBACK FOR CORRECT ANSWERS</div>
                  <div style={{ color: "#8493B2" }}>
                    {question.currentAnswerFeedback}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <div onClick={handelEditFeedBack}>
                    <img src={editNotificationicon} alt="" />
                  </div>
                  <div
                    onClick={() =>
                      handelDeleteFeedBack("currentAnswerFeedback")
                    }
                  >
                    <img src={deleteNotificationIcon} alt="" />
                  </div>
                </div>
              </div>
            )}
            {question.inCurrentAnswerFeedback !== "" && (
              <div className="show-feedback-container">
                <div className="show-feedback-container-text-container">
                  <div>FEEDBACK FOR CORRECT ANSWERS</div>
                  <div style={{ color: "#8493B2" }}>
                    {question.inCurrentAnswerFeedback}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <div onClick={handelEditFeedBack}>
                    <img src={editNotificationicon} alt="" />
                  </div>
                  <div
                    onClick={() =>
                      handelDeleteFeedBack("inCurrentAnswerFeedback")
                    }
                  >
                    <img src={deleteNotificationIcon} alt="" />
                  </div>
                </div>
              </div>
            )}
            <div className="updated-answer-key-and-feedback">
              <button onClick={updatedCorrectAnswer}>Done</button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="singleQuestion-Container">
            {questionIndex + 1}.
            <ReactQuill
              modules={module}
              theme="snow"
              className={`custom ${
                openQuestion === question.id ? "focus" : ""
              }`}
              onFocus={() => setOpenQuestion(question.id)}
              onBlur={() => setOpenQuestion(null)}
              value={question.question}
              onChange={handleQuestionChange}
            />
          </div>
          <div>
            {question.options.map((data, index) => (
              <div
                className="choice-box"
                key={index}
                onClick={() => console.log(multiOtionFocused)}
              >
                <img src={singleChoiceIcon} alt="singleChoiceIcon" />
                <input
                  type="text"
                  placeholder={`Add choice ${data.optionText}`}
                  value={data.optionText}
                  className="choice-input"
                  onFocus={() => {
                    setMultiOptionfocused(data._id); // Set focused question ID
                  }}
                  onBlur={() => setMultiOptionfocused(null)}
                  onChange={(e) =>
                    handleOptionTextChange(index, e.target.value)
                  }
                />
                <img
                  src={optionDND}
                  alt="optionDND"
                  style={{
                    display: multiOtionFocused === data._id ? "block" : "none",
                  }}
                  className="optionTrash"
                />
                <img
                  src={optionTrash}
                  alt="trash"
                  style={{
                    display: multiOtionFocused === data._id ? "block" : "none",
                  }}
                  onClick={() => deleteSingleChoiceOp(index)}
                />
              </div>
            ))}
            <div className="choice-box" onClick={() => addNewOption()}>
              <img src={addSingleOptionButton} alt="addSingleOptionButton" />
              <p>Add Option</p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {generalSettings.isQuiz && (
                <div
                  onClick={() => handelAddAnswerKey(question.id)}
                  style={{
                    display: "flex",
                    gap: "0.71rem",
                    color: "#1B51BB",
                    alignItems: "center",
                    zIndex: 100,
                  }}
                >
                  <img src={answerKeyIcon} alt="answerKeyIcon" />
                  Answer key
                </div>
              )}
              <div className="required-container">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={question.required}
                    onChange={(e) =>
                      handleRequiredChange(
                        questionIndex,
                        containerIndex,
                        e.target.checked
                      )
                    }
                  />
                  <span className="slider"></span>
                </label>
                <p className="required-text">Required</p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MultipleChoiceQuestion;
